import { render, staticRenderFns } from "./ActiveForm.vue?vue&type=template&id=bed633b0&scoped=true&"
import script from "./ActiveForm.vue?vue&type=script&lang=js&"
export * from "./ActiveForm.vue?vue&type=script&lang=js&"
import style0 from "./ActiveForm.vue?vue&type=style&index=0&id=bed633b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed633b0",
  null
  
)

export default component.exports